"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var CardRowTextEditor_1 = require("../../../../../../shared/components/editors/CardRowTextEditor");
var CardRowButtonSet_1 = require("../../../../../../shared/components/editors/CardRowButtonSet");
var notificationHelper_1 = require("../../../../../../shared/helpers/notificationHelper");
var CardEditorContainer_1 = require("../../../../../../shared/components/containers/CardEditorContainer");
var CardRowSelectEditor_1 = require("../../../../../../shared/components/editors/CardRowSelectEditor");
//import { CmsPostsRecordsListCtl, ICmsPostsRecordsListItem } from "../../ctl/CmsPostsRecordsListCtl";
var CardRowTextAreaEditor_1 = require("../../../../../../shared/components/editors/CardRowTextAreaEditor");
var CardRowButtonTextEditor_1 = require("../../../../../../shared/components/editors/CardRowButtonTextEditor");
var EventBindingDescriptionEditor = /** @class */ (function (_super) {
    __extends(EventBindingDescriptionEditor, _super);
    function EventBindingDescriptionEditor(props) {
        return _super.call(this, props) || this;
    }
    EventBindingDescriptionEditor.prototype.componentWillMount = function () {
        var _this = this;
        if (this.props.record) {
            this.setState({
                title: this.props.record.title,
                teaser_image_url: this.props.record.teaser_image_url,
                lang_id: this.props.record.app_language_id,
                lang_title: this.props.record.app_language_title,
                description_text: this.props.record.description,
                detail_text: this.props.record.details
            }, function () {
                _this.props.state.setExtBreadCrumbPath(["Список событий", "Редактирование описания"]);
            });
        }
        else {
            this.setState({
                title: "",
                lang_id: -1,
                lang_title: "",
                description_text: "",
                detail_text: "",
                teaser_image_url: ""
            }, function () {
                _this.props.state.setExtBreadCrumbPath(["Список событий", "Создание описания"]);
            });
        }
        this.doReSetRules();
    };
    EventBindingDescriptionEditor.prototype.doReSetRules = function () {
        this.setState({
            title_rules: { isError: false },
            lang_rules: { isError: false },
            teaser_image_url_rules: { isError: false },
            description_text_rules: { isError: false },
            detail_text_rules: { isError: false }
        });
    };
    EventBindingDescriptionEditor.prototype.OnUpdateDataClick = function () {
        if (this.isDataValid()) {
            this.props.data.EditData({
                key: this.props.record.key,
                title: this.state.title,
                app_language_id: this.state.lang_id,
                description: this.state.description_text,
                details: this.state.detail_text,
                teaser_img_url: this.state.teaser_image_url
            }, function () {
                notificationHelper_1.default.ShowTextTopRightInfoNotify("Запись изменена!");
            });
        }
    };
    EventBindingDescriptionEditor.prototype.isDataValid = function () {
        this.doReSetRules();
        if ((!this.state.title) || (this.state.title.length === 0)) {
            this.setState({ title_rules: { isError: true, errorMessage: "Поле [название] не заполнено!" } });
            return false;
        }
        if ((this.state.lang_id <= 0) || (this.state.lang_title.length === 0)) {
            this.setState({
                lang_rules: { isError: true, errorMessage: "Поле [язык] не выбрано!" }
            });
            return false;
        }
        if ((!this.state.description_text) || (this.state.description_text.length === 0)) {
            this.setState({ description_text_rules: { isError: true, errorMessage: "Поле [Описание записи] не заполнено!" } });
            return false;
        }
        if ((!this.state.detail_text) || (this.state.detail_text.length === 0)) {
            this.setState({ detail_text_rules: { isError: true, errorMessage: "Поле [Детали записи] не заполнено!" } });
            return false;
        }
        if ((!this.state.teaser_image_url) || (this.state.teaser_image_url.length === 0)) {
            this.setState({ teaser_image_url_rules: { isError: true, errorMessage: "Поле [изображение] не выбрано!" } });
            return false;
        }
        return true;
    };
    EventBindingDescriptionEditor.prototype.OnNewDataClick = function () {
        if (this.isDataValid()) {
            this.props.data.AddData({
                event_binding_id: this.props.rootRecord.key,
                app_language_id: this.state.lang_id,
                title: this.state.title,
                teaser_img_url: this.state.teaser_image_url,
                description: this.state.description_text,
                details: this.state.detail_text
            }, function () {
                notificationHelper_1.default.ShowTextTopRightInfoNotify("Запись добавлена!");
            });
        }
    };
    EventBindingDescriptionEditor.prototype.OnGoBackClick = function () {
        if (this.props.onGoBack) {
            this.props.onGoBack();
        }
    };
    EventBindingDescriptionEditor.prototype.getFormTitle = function () {
        if (!this.props.record) {
            return "Добавить запись";
        }
        else {
            return "Изменить запись";
        }
    };
    EventBindingDescriptionEditor.prototype.DoShowSelectImageDialog = function () {
        var _this = this;
        this.props.dialogSelectImage.SetDialogTitle("Выбор изображения").SetOnSelect(function (brandIdentity, dirName, fileName) {
            _this.setState({ teaser_image_url: brandIdentity + "/" + dirName + "/" + fileName }, function () {
                _this.props.dialogSelectImage.Close();
            });
        }).Show();
    };
    EventBindingDescriptionEditor.prototype.render = function () {
        var _this = this;
        return (React.createElement(CardEditorContainer_1.default, { onGoBackClick: this.OnGoBackClick.bind(this), title: this.getFormTitle(), state: this.props.state, maxHeight: 780 },
            React.createElement(CardRowTextEditor_1.default, { texts: { caption: "Заголовок:", placeholder: "Введите заголовок описания" }, value: this.state.title, onValueChanged: function (newVal) {
                    _this.setState({
                        title: newVal,
                        title_rules: { isError: false }
                    });
                }, required: true, rules: this.state.title_rules }),
            React.createElement(CardRowSelectEditor_1.default, { texts: { caption: "Язык:", placeholder: "Выберите язык" }, value: { key: this.state.lang_id, value: this.state.lang_title }, onValueChanged: function (newVal) {
                    _this.setState({
                        lang_id: newVal.key,
                        lang_title: newVal.value,
                        lang_rules: { isError: false },
                    });
                }, items: this.props.languagesList, disabled: this.props.record != null, required: true, rules: this.state.lang_rules }),
            React.createElement(CardRowButtonTextEditor_1.default, { texts: {
                    caption: "Изображение:",
                    placeholder: "Выберите изображение",
                    buttonHint: "Выберите изображение"
                }, readonly: true, onButtonClick: this.DoShowSelectImageDialog.bind(this), onValueChanged: function (newVal) {
                    _this.setState({
                        teaser_image_url: newVal,
                        teaser_image_url_rules: { isError: false }
                    });
                }, value: this.state.teaser_image_url, buttonIcon: "search", required: true, rules: this.state.teaser_image_url_rules }),
            React.createElement(CardRowTextAreaEditor_1.default, { texts: { caption: "Описание записи:", placeholder: "Введите текст описания записи" }, value: this.state.description_text, onValueChanged: function (newVal) {
                    _this.setState({ description_text: newVal, description_text_rules: { isError: false } });
                }, rowsCount: 8, required: true, rules: this.state.description_text_rules }),
            React.createElement(CardRowTextAreaEditor_1.default, { texts: { caption: "Детали записи:", placeholder: "Введите текст деталей записи" }, value: this.state.detail_text, onValueChanged: function (newVal) {
                    _this.setState({ detail_text: newVal, detail_text_rules: { isError: false } });
                }, rowsCount: 8, required: true, rules: this.state.detail_text_rules }),
            React.createElement(CardRowButtonSet_1.default, { editMode: this.props.record != null, title: { btnEdit: "Сохранить", btnNew: "Создать", btnGoBack: "Вернуться" }, onGoBackClick: this.OnGoBackClick.bind(this), onAddClick: this.OnNewDataClick.bind(this), onEditClick: this.OnUpdateDataClick.bind(this) })));
    };
    return EventBindingDescriptionEditor;
}(React.Component));
exports.default = EventBindingDescriptionEditor;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/gift_events_bindings/ui/component/EventBindingDescriptionEditor.tsx
// module id = 1986
// module chunks = 0